/**
 * Modulo Lazyloading
 * @module abstracts/lazyloading
 * @namespace Abstracts/Lazyloading
 */
// import ViewsCollections from './collections/views-collection'
import Core from '../core'
import $ from 'jquery'
// import _ from 'underscore'
/**
 * Classe responsável por gestão de elementos lazyloading
 *
 * @name Lazyloading
 * @typedef {Object} Lazyloading
 * @memberof abstracts/lazyloading
 */
class Lazyloading {
    _Views = []

    init () {
        Core.Tasks.add(Core.Events.PAGE_SCROLL, () => {
            this.checkAll()
        })
    }

    addView (view) {
        view.repeat = (typeof view.repeat !== 'undefined') ? view.repeat : false

        if (this._checkDisplaying(view.$el)) {
            view.trigger(Core.Events.SHOW_ELEMENT, view.$el)
            if (view.repeat === false) {
                return
            }
        }

        // this._ViewsCollections.add({ view, $el: view.$el, repeat: view.repeat })
        this._Views.push(view)
    }

    async checkAll () {
        if (this._Views.length === 0) {
            return
        }

        // const length = this._Views.length
        // const list = _.clone(this._Views)
        const promises = []
        for (let i = 0; i < this._Views.length; i++) {
            promises.push(new Promise((resolve, reject) => {
                (() => {
                    try {
                        const view = this._Views[i]

                        if (view.executed) {
                            resolve(true)
                        }
                        // Checa se o elemento está visível
                        if (this._checkDisplaying(view.$el)) {
                            // console.log('lazyloading', 'found', view)

                            // view.trigger(Core.Events.SHOW_ELEMENT)
                            // agora o padrão é esse
                            view.render()

                            // Deleta o elemento do array
                            // if (!view.repeat) {
                            //     this._Views.splice(i, 1)
                            // }
                            // return true para a promise
                        }
                    } catch (ex) {
                        console.error(ex)
                    }

                    resolve(true)
                })()
            }))
        }

        await Promise.all(promises)
    }

    _checkDisplaying ($el) {
        if (typeof $ === 'undefined' || !$el) {
            return
        }

        const windowHeight = $(window).height()

        const scrollTop = $(window).scrollTop()

        const actionAreaTotal = [scrollTop, scrollTop + windowHeight + 250]

        const offset = $el.offset().top

        // console.log('lazyloading', $el, offset, actionAreaTotal)

        // se o top do elemento for 0 possivelmente o display está none
        if ($el.offset().top === 0) {
            return false
        }

        if (offset >= actionAreaTotal[0] && offset <= actionAreaTotal[1]) {
            return true
        }

        return false
    }

    async force () {
        // view.$el.hasClass('force')
        if (this._Views.length === 0) {
            return
        }

        const promises = []
        for (let i = 0; i < this._Views.length; i++) {
            promises.push(new Promise((resolve, reject) => {
                (() => {
                    try {
                        const view = this._Views[i]

                        if (view.executed) {
                            resolve(true)
                        }
                        // Checa se o elemento está visível
                        if (view.$el.hasClass('force')) {
                            // console.log('lazyloading', 'found', view)

                            // view.trigger(Core.Events.SHOW_ELEMENT)
                            // agora o padrão é esse
                            view.render()

                            // Deleta o elemento do array
                            // if (!view.repeat) {
                            //     this._Views.splice(i, 1)
                            // }
                            // return true para a promise
                        }
                    } catch (ex) {
                        console.error(ex)
                    }

                    resolve(true)
                })()
            }))
        }

        await Promise.all(promises)
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Lazyloading = Lazyloading
